/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIPlanningEnum } from './APIPlanningEnum';
import {
    APIPlanningEnumFromJSON,
    APIPlanningEnumFromJSONTyped,
    APIPlanningEnumToJSON,
} from './APIPlanningEnum';

/**
 * Enables including one or more articles in the Request creation.
 * Supports:
 * - Single article (backward compatibility)
 * - Multiple articles (articles array)
 * - Articles with quantities (articles_with_quantities array)
 * @export
 * @interface APIRequestCreation
 */
export interface APIRequestCreation {
    /**
     * 
     * @type {string}
     * @memberof APIRequestCreation
     */
    readonly self: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestCreation
     */
    readonly rootAccountName: string;
    /**
     * 
     * @type {Array<object>}
     * @memberof APIRequestCreation
     */
    readonly requestArticles: Array<object>;
    /**
     * 
     * @type {Array<string>}
     * @memberof APIRequestCreation
     */
    editors?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof APIRequestCreation
     */
    contact?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestCreation
     */
    readonly files: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIRequestCreation
     */
    readonly read: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof APIRequestCreation
     */
    isTemp?: boolean;
    /**
     * 
     * @type {Array<number>}
     * @memberof APIRequestCreation
     */
    readonly quantities: Array<number>;
    /**
     * Calculated costs listed together with quantities as JSON object like {'100': '100', '200': '200', ...}
     * @type {{ [key: string]: any; }}
     * @memberof APIRequestCreation
     */
    calculatedCosts?: { [key: string]: any; };
    /**
     * Detailed calculated costs per quantity written down as JSON object like {'100': {'estimated_price': '€ 10.00', 'estimated_material_cost': '€ 2.00', ...}, ...}
     * @type {{ [key: string]: any; }}
     * @memberof APIRequestCreation
     */
    calculatedCostBreakdown?: { [key: string]: any; };
    /**
     * The costs per quantity reported by suppliers written down as JSON object like {'supplier_1': {quantity_1: price_1, quantity_2: price_2, ...}, ...}
     * @type {{ [key: string]: any; }}
     * @memberof APIRequestCreation
     */
    reportedCosts?: { [key: string]: any; };
    /**
     * Optional price suggestion provided by the customer.
     * @type {string}
     * @memberof APIRequestCreation
     */
    customerPriceSuggestion?: string;
    /**
     * 
     * @type {Date}
     * @memberof APIRequestCreation
     */
    wishDate?: Date | null;
    /**
     * 
     * @type {APIPlanningEnum}
     * @memberof APIRequestCreation
     */
    status: APIPlanningEnum;
    /**
     * 
     * @type {boolean}
     * @memberof APIRequestCreation
     */
    priority?: boolean;
    /**
     * 
     * @type {string}
     * @memberof APIRequestCreation
     */
    remarks?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestCreation
     */
    certificate?: string;
    /**
     * 
     * @type {string}
     * @memberof APIRequestCreation
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof APIRequestCreation
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof APIRequestCreation
     */
    readonly lastModifiedAt: Date;
    /**
     * Contact person for this Request.
     * @type {number}
     * @memberof APIRequestCreation
     */
    readonly contactId: number | null;
}



/**
 * Check if a given object implements the APIRequestCreation interface.
 */
export function instanceOfAPIRequestCreation(value: object): value is APIRequestCreation {
    if (!('self' in value) || value['self'] === undefined) return false;
    if (!('rootAccountName' in value) || value['rootAccountName'] === undefined) return false;
    if (!('requestArticles' in value) || value['requestArticles'] === undefined) return false;
    if (!('files' in value) || value['files'] === undefined) return false;
    if (!('read' in value) || value['read'] === undefined) return false;
    if (!('quantities' in value) || value['quantities'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('lastModifiedAt' in value) || value['lastModifiedAt'] === undefined) return false;
    if (!('contactId' in value) || value['contactId'] === undefined) return false;
    return true;
}

export function APIRequestCreationFromJSON(json: any): APIRequestCreation {
    return APIRequestCreationFromJSONTyped(json, false);
}

export function APIRequestCreationFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIRequestCreation {
    if (json == null) {
        return json;
    }
    return {
        
        'self': json['self'],
        'rootAccountName': json['root_account_name'],
        'requestArticles': json['request_articles'],
        'editors': json['editors'] == null ? undefined : json['editors'],
        'contact': json['contact'] == null ? undefined : json['contact'],
        'files': json['files'],
        'read': json['read'],
        'isTemp': json['is_temp'] == null ? undefined : json['is_temp'],
        'quantities': json['quantities'],
        'calculatedCosts': json['calculated_costs'] == null ? undefined : json['calculated_costs'],
        'calculatedCostBreakdown': json['calculated_cost_breakdown'] == null ? undefined : json['calculated_cost_breakdown'],
        'reportedCosts': json['reported_costs'] == null ? undefined : json['reported_costs'],
        'customerPriceSuggestion': json['customer_price_suggestion'] == null ? undefined : json['customer_price_suggestion'],
        'wishDate': json['wish_date'] == null ? undefined : (new Date(json['wish_date'])),
        'status': APIPlanningEnumFromJSON(json['status']),
        'priority': json['priority'] == null ? undefined : json['priority'],
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
        'certificate': json['certificate'] == null ? undefined : json['certificate'],
        'description': json['description'] == null ? undefined : json['description'],
        'createdAt': (new Date(json['created_at'])),
        'lastModifiedAt': (new Date(json['last_modified_at'])),
        'contactId': json['contact_id'],
    };
}

export function APIRequestCreationToJSON(value?: Omit<APIRequestCreation, 'self'|'root_account_name'|'request_articles'|'files'|'read'|'quantities'|'created_at'|'last_modified_at'|'contact_id'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'editors': value['editors'],
        'contact': value['contact'],
        'is_temp': value['isTemp'],
        'calculated_costs': value['calculatedCosts'],
        'calculated_cost_breakdown': value['calculatedCostBreakdown'],
        'reported_costs': value['reportedCosts'],
        'customer_price_suggestion': value['customerPriceSuggestion'],
        'wish_date': value['wishDate'] == null ? undefined : ((value['wishDate'] as any).toISOString().substring(0,10)),
        'status': APIPlanningEnumToJSON(value['status']),
        'priority': value['priority'],
        'remarks': value['remarks'],
        'certificate': value['certificate'],
        'description': value['description'],
    };
}

